import Typography from '@mui/material/Typography/Typography';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { AuthenticationSuccess } from 'src/routes/public/Authentication/AuthenticationSuccess';

const SignUpSuccess = () => (
    <>
        <title>Victron Professional - Sign Up Success</title>
        <AuthenticationSuccess
            title={
                <FormattedMessage
                    id="auth.signUpSuccess.title"
                    defaultMessage="Account Created Successfully"
                    description="Success title after account creation. Used in: /auth/sign-up/success"
                />
            }
            message={
                <>
                    <Typography fontFamily="Roboto" fontWeight={700} fontSize={14} mt={1} letterSpacing={0.17}>
                        <FormattedMessage
                            id="auth.signUpSuccess.welcome"
                            defaultMessage="Welcome to Victron OneID"
                            description="Success welcome message after account creation with email verification notice. Used in: /auth/sign-up/success"
                        />
                    </Typography>
                    <Typography fontFamily="Roboto" fontSize={14} letterSpacing={0.17}>
                        <FormattedMessage
                            id="auth.signUpSuccess.emailVerification"
                            defaultMessage="OneID gives you secure and convenient access to all Victron Services like VRM and Victron Professional. Please create a password and optional 2 factor authentication. After your account has been confirmed you will automatically be sent back to Victron Professional."
                            description="Success message after account creation with email verification notice. Used in: /auth/sign-up/success"
                        />
                    </Typography>
                    <Typography fontFamily="Roboto" fontSize={14} mt={2} letterSpacing={0.17}>
                        <FormattedMessage
                            id="auth.signUpSuccess.continue"
                            defaultMessage="Your account for Victron Professional has been created successfully. Please check your email to verify your account."
                            description="Success message after account creation with email verification notice. Used in: /auth/sign-up/success"
                        />
                    </Typography>
                </>
            }
            primaryButtonProps={{
                children: (
                    <FormattedMessage
                        id="common.continue"
                        defaultMessage="Continue"
                        description="Text for continue button"
                    />
                ),
                component: Link,
                to: { pathname: '../login', search: window.location.search },
            }}
            stateVariable="sign-up-allow"
        />
    </>
);

export { SignUpSuccess };
